exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!@fortawesome/fontawesome-svg-core/styles.css"), "");

// module
exports.push([module.id, ".amt-widget-row{display:flex !important;justify-content:flex-end !important}.amt-widget-toggle button{font-size:12px;background-color:#6fb7e5;color:#fff;border:none;outline:none;height:40px;min-width:137px}.amt-widget-toggle button.amt-render-widget{border-radius:5px;font-size:12px;padding:10px;text-transform:uppercase}.amt-widget-toggle button.amt-destroy-widget{width:50px;height:50px;border-radius:50%;font-size:26px;min-width:auto}.amt-widget-toggle button:hover{background-color:#44a1dd;cursor:pointer}\n", ""]);

// exports
